import * as React from 'react';
import { useFormikAutoSave } from '../../../utils/autoSave.util';

export const AutoSave = () => {
  useFormikAutoSave({ debounceMs: 10000 });
  return <div />;
};
